app.service('systemService', function ( $http, $location, safeApply) {

    this.functionCall = function (obj) {
    return $http.post(`/system/server/functionCall`, obj)
      .then(function (response) {
        return response
      })
  }

  this.route_change = function (route, params) {
    let path
    switch (route) {
      case 'registration':
        path = `https://dashboard.propertytax.io/signup/${params.cad_code}/${params.account}`
        window.location.href = path
        break
      case 'login':
        path = `https://dashboard.propertytax.io/signin`
        window.location.href = path
        break
      case 'pricing':
        path = `/pricing`
        $location.path(path)
        break
      case 'help':
        path = `/help`
        $location.path(path)
        break
      case 'about_us':
        path = `/about_us`
        $location.path(path)
        break

      case 'analysis':
        path = `/analysis/${params.uid}`
        $location.path(path)
        break
      case '/':
        path = `/`
        $location.path(path)
        break
    }
  }
  
})